import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';

export class PutEmailTemplateCommand extends IRequestCommand<
  IPutEmailTemplateCommandResponse,
  ErrorDetails,
  IPutEmailTemplateCommandParameters> {
    override _commandType: CommandRequestType = CommandRequestType.PUT;
    override _commandUrl = "carriers/{carrierId}/emailsTemplates"

   public override setParameters(parameters: IPutEmailTemplateCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId ? parameters.carrierId.toString() : ''
    );
    this._commandBody = parameters;
  }
}

export interface IPutEmailTemplateCommandParameters extends ICommandParameters {
    carrierId: number,
    id: number,
    userId: number,
    html: string,
    logoPlacement: string,
    languageCode: string,
    userType: string
}

export interface IPutEmailTemplateCommandResponse extends ICommandResponse {
}
